/**
 * Utility for creating a Proximity Sensor.
 *
 * @param {Function} onChange - Callback function to execute when the proximity reading changes.
 *                              Receives the distance or value as an argument.
 * @returns {ProximitySensor|null} The created sensor instance or null if not supported.
 */
export function createProximitySensor(onChange) {
  let sensor = null;
  if ('ProximitySensor' in window) {
    try {
      sensor = new window.ProximitySensor();
      sensor.addEventListener('reading', () => {
        onChange(sensor.distance);
      });
      sensor.addEventListener('error', (event) => {
        console.error('ProximitySensor error:', event.error.name, event.error.message);
      });
      sensor.start();
    } catch (e) {
      console.error('ProximitySensor not available:', e);
    }
  } else if ('ondeviceproximity' in window) {
    // Fallback for older browsers
    window.addEventListener('deviceproximity', (event) => {
      onChange(event.value);
    });
  } else {
    console.warn('Proximity sensor not supported on this device/browser.');
  }
  return sensor;
} 